<template>
	<div class="page">
		<div class="scroll-box">
			<p class="text">
				欢迎您使用数智产投！本协议是您与 [APP 运营公司名称] 就您使用本 APP 相关服务所订立的协议，请您仔细阅读。一旦您使用本
				APP，即表示您已阅读、理解并同意接受本协议的全部内容。
			</p>
			<h4 class="title">一、协议的适用及变更</h4>
			<p class="text">
				1.1　本协议适用于所有使用本 APP 的用户。
				<br />
				1.2　我们有权根据需要不定期地制订、修改本协议或各类规则，并在 APP 平台公示，不再另行单独通知用户。您继续使用本 APP，即视为接受修订后的协议和规则。
			</p>
			<h4 class="title">二、账号注册与管理</h4>
			<p class="text">
				2.1　您在注册账号时，应按注册页面引导提供个人资料。我们有权对您注册信息的有效性进行审核，注册信息不符合要求的，我们有权终止向您提供服务，并保留注销您账号的权利。
				<br />
				2.2　您的账号所有权归我们所有，您完成申请注册手续后，仅获得账号的使用权。您有义务保证密码和账号的安全，因您的保管疏忽等导致账号非法使用，我们不承担任何责任。
				<br />
			</p>
			<h4 class="title">三、服务内容及变更</h4>
			<p class="text">
				3.1　我们为您提供 APP 内的各类服务，具体内容根据实际情况提供。
				<br />
				3.2　为了提升用户体验、完善业务功能等，我们有权采用包括但不限于软件修改、替换、功能优化、版本升级等形式，对本 APP 进行更新升级或对服务功能、内容等进行调整。
				<br />
				3.3 我们根据系统升级、改造需要，拥有未经事先通知而修改软件功能、暂时中止提供服务的权利。因行使上述修改或中止软件使用而造成的任何损失，我们不需对您或任何第三方负责。
				<br />
			</p>
			<h4 class="title">四、服务内容及变更</h4>
			<p class="text">
				4.1　我们依法保护您的个人信息安全，但在一些情况下可能会向第三方提供您的注册资料，例如：事先获得您的明确授权；根据有关的法律法规要求；按照相关政府主管部门的要求；为维护社会公众的利益；为维护本 APP
				的合法权益等。
				<br />
				4.2　对于我们如何具体收集、使用、存储和保护您的个人信息，可能会在其他相关政策或说明中有进一步阐述，但具体细节我们保留进一步解释和调整的权利。
				<br />
			</p>
			<h4 class="title">五、第三方产品和服务</h4>
			<p class="text">
				5.1　如您使用的服务功能涉及第三方提供的服务，除遵守本协议约定外，您还应同时遵守第三方的服务协议和规则。
				<br />
				5.2　由第三方提供的服务，其正确性、准确性、安全性、有效性及任何可能发生的不确定风险，与我们无关。由上述引发的任何争议或损害，我们不承担任何责任。因本 APP
				使用的第三方软件或技术引发的任何纠纷，应由第三方负责解决，我们不承担任何责任。
				<br />
			</p>
			<h4 class="title">六、知识产权声明</h4>
			<p class="text">
				6.1　本 APP 的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本 APP
				相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受法律法规的保护，我们依法享有相应的知识产权。未经我们或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。
				<br />
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ServiceAgreement',
	data() {
		return {}
	},
	mounted() {
		// 页面加载完成后执行的代码
		document.title = '服务协议'
	},
	methods: {}
}
</script>

<style scoped>
.page {
	min-height: 100vh;
	background-color: #fff;
}

.header {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 44px;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 16px;
	border-bottom: 1px solid #eee;
	z-index: 100;
}

.back-icon {
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.icon-back {
	font-style: normal;
	font-size: 18px;
	color: #333;
}

.header-title {
	flex: 1;
	font-size: 17px;
	font-weight: 500;
	color: #333;
	margin-right: 24px;
  text-align: center;
}

.scroll-box {
	box-sizing: border-box;
	padding: 0 16px;
}

.title {
	padding-top: 20px;
	margin-bottom: 12px;
	font-size: 15px;
	color: #333;
	font-weight: 500;
}

.text {
	line-height: 1.6;
	font-size: 14px;
	color: #333;
	margin-bottom: 8px;
}
</style>